import React from "react";
import BaseField from "./BaseField";

export default function InstructionField({
  field,
  renderInlineChildren,
  openViewer,
  previewMode = false,
}) {
  return (
    <BaseField
      field={field}
      value={null}
      setValue={() => {}}
      openViewer={openViewer}
      renderInlineChildren={renderInlineChildren}
      previewMode={previewMode}
    >
      <div className="p-3 bg-white dark:bg-gray-700 rounded-lg border border-gray-300 dark:border-gray-600">
        <p className="text-sm text-gray-700 dark:text-gray-200 whitespace-pre-line text-center">
          {field.config?.text || "Instruction text..."}
        </p>
      </div>
    </BaseField>
  );
}
